import React from 'react';

const CloseIcon = (props: any) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.03113 4.03003L9.97082 9.96973" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.02928 9.96983L9.96898 4.03014" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default CloseIcon;
